import React, { useState, useEffect } from 'react';
import { Table, Progress, message } from 'antd';
import { getCoursesReport } from '../../api/reports';
import { numberSorter, textSorter } from '../../utils/tableSorters';

const CoursesReportTab = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCoursesReport()
      .then(res => setData(res.data))
      .catch(() => message.error('Kurs raporu yüklenemedi.'))
      .finally(() => setLoading(false));
  }, []);

  // Liste tamamen bellekte - istemci siralayicilari dogru sonuc verir.
  const columns = [
    {
      title: 'Sertifika Programı',
      dataIndex: 'course_name',
      sorter: textSorter('course_name'),
    },
    { title: 'Toplam Proje', dataIndex: 'total_topics', align: 'center', sorter: numberSorter('total_topics') },
    { title: 'Kayıtlı Öğrenci', dataIndex: 'enrolled_students', align: 'center', sorter: numberSorter('enrolled_students') },
    {
      title: 'Tamamlayan',
      dataIndex: 'completed_students',
      align: 'center',
      sorter: numberSorter('completed_students'),
      render: v => <span className="text-green-600 font-medium">{v}</span>,
    },
    {
      title: 'Tamamlanma Oranı',
      dataIndex: 'completion_rate',
      align: 'center',
      sorter: numberSorter('completion_rate'),
      render: v => (
        <div className="flex items-center gap-2">
          <Progress
            percent={v}
            size="small"
            style={{ width: 80, marginBottom: 0 }}
            strokeColor={v >= 70 ? '#52c41a' : v >= 40 ? '#faad14' : '#ff4d4f'}
          />
          <span className="text-xs">{v}%</span>
        </div>
      ),
    },
    {
      title: 'Ortalama İlerleme',
      dataIndex: 'avg_progress',
      align: 'center',
      sorter: numberSorter('avg_progress'),
      render: v => (
        <div className="flex items-center gap-2">
          <Progress percent={v} size="small" style={{ width: 80, marginBottom: 0 }} strokeColor="#1677ff" />
          <span className="text-xs">{v}%</span>
        </div>
      ),
    },
  ];

  return (
    <Table
      dataSource={data || []}
      rowKey="course_id"
      columns={columns}
      size="small"
      loading={loading}
      pagination={{ pageSize: 20 }}
    />
  );
};

export default CoursesReportTab;
